<template>
    <div
        class="w-full h-1.5 bg-gray-200 rounded-full overflow-hidden"
        role="progressbar"
        :aria-valuemin="0"
        :aria-valuemax="100"
        :aria-valuenow="clamped"
    >
        <div
            class="h-full bg-primary-3 rounded-full transition-[width] duration-300 ease-out"
            :style="{ width: clamped + '%' }"
        />
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: {
        percent: { type: Number, required: true }, // 0~100
    },
    computed: {
        clamped() {
            return Math.max(0, Math.min(100, this.percent));
        },
    },
};
</script>
